export const TEMPLATE_TYPES = {
  JOB: "job",
  LEG: "leg",
};

/** Shared control size for job/leg template modals. */
export const TEMPLATE_FORM_SIZE = "sm";

/** Textarea styling aligned with `TEMPLATE_FORM_SIZE` inputs. */
export const TEMPLATE_TEXTAREA_CLASS =
  "block w-full rounded-lg border border-gray-300 p-2 text-xs text-gray-900 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500";

export const TEMPLATE_TYPE_LABELS = {
  [TEMPLATE_TYPES.JOB]: "Job",
  [TEMPLATE_TYPES.LEG]: "Leg",
};

export const JOB_DEFAULT_FIELDS = [
  "orderNumber",
  "loadNumber",
  "transactionDate",
  "originalCall",
  "appointmentDate",
  "useFlatRate",
  "flatRate",
  "baseRate",
  "fuelRate",
  "summary",
  "priority",
];

export const LEG_DEFAULT_FIELDS = [
  "loadType",
  "status",
  "origin",
  "destination",
  "weight",
  "driver",
  "appointmentDate",
  "appointmentTime",
  "useLegFlatRate",
  "baseCharge",
  "fuelSurcharge",
  "dropCharge",
  "otherCharges",
  "totalMiles",
  "defaultMileage",
  "customMileage",
  "billedMiles",
  "mileageSelectionType",
  "useCustomMileage",
  "useCustomBaseCharge",
  "useCustomFuelSurcharge",
  "useCustomDropCharge",
  "useCustomOtherCharges",
  "waitTime",
  "waitStart",
  "waitEnd",
  "totalWaitTime",
  "hasHandoff",
  "isHandoff",
];

export const LOAD_TYPE_OPTIONS = [
  { label: "Regular", value: "Regular" },
  { label: "Empty", value: "Empty" },
  { label: "Bobtail", value: "Bobtail" },
];

export const LEG_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Assigned", value: "assigned" },
  { label: "At Pickup", value: "atpickup" },
  { label: "In Transit", value: "intransit" },
  { label: "At Delivery", value: "atdelivery" },
];

export const MILEAGE_SELECTION_OPTIONS = [
  { label: "Default Mileage", value: "defaultMileage" },
  { label: "Billed Mileage", value: "billedMileage" },
  { label: "Custom Input", value: "customInput" },
];
